import React from "react";
import "../style.css";
import { setOpenFacilitySelect } from "../../../store/config/configActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const StrzelnicaPage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <body
      style={{
        fontFamily: '"Montserrat", sans-serif',
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        zIndex: 10000,
      }}
    >
      <div className="strzelnica-bg">
        <div className="head">
          <div>
            <img className="logo2" src={`${process.env.PUBLIC_URL}/img/rcs.png`} />
          </div>
          <h1 style={{ color: "green", fontWeight: 800 }}>STRZELNICA</h1>
        </div>
        <p className="txt">
          Sprzedaż internetowa pakietów na Strzelnicę jest niedostępna. Do zakupu zapraszamy na obiekt.{" "}
        </p>
        <p className="txt" style={{ color: "green" }}>
          Godziny otwarcia:
        </p>
        <p className="txt">
          poniedziałek - piątek / 14.00 - 22.00
          <br />
        </p>
        sobota i niedziela / 9.00 - 22.00
        <p className="txt" style={{ color: "green" }}>
          Kontakt i rezerwacja:
        </p>
        <p className="txt">
          tel. 783 018 316
          <br />
          e-mail: strzelnica@rcslubin.pl
          <a
            href="#"
            onClick={() => {
              history.push("/");
              dispatch(setOpenFacilitySelect(true));
            }}
            id=""
            title="strzelnica"
          >
            strzelnica
          </a>
        </p>
        <p className="txt">
          Strzelnica sportowa zlokalizowana jest w Lubinie przy ul. Baczynowej 3, 59-300 Lubin.
          <br />
          Więcej informacji na stronie: <a href="http://rcslubin.pl/strzelnica">http://rcslubin.pl/strzelnica</a>
        </p>
      </div>
    </body>
  );
};

export default StrzelnicaPage;
